var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "login-page" },
    [
      _c("loading", {
        attrs: { active: _vm.isLoading, loader: "dots" },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("div", { staticClass: "login-wrap" }, [
        _c("div", { staticClass: "cover-wrap" }, [
          _c("div", { staticClass: "cover-inner" }, [
            _c("div", { staticClass: "sign-text-wrap" }, [
              _c("div", { staticClass: "title" }, [_c("LogoLight")], 1),
              _vm._m(0),
              _c(
                "div",
                { staticClass: "sign-btn", on: { click: _vm.goHomePage } },
                [_vm._v("首頁")]
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "login-form-wrap" }, [
          _c("div", { staticClass: "login-form-inner" }, [
            _c(
              "form",
              {
                staticClass: "login-form",
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.managerSignIn.apply(null, arguments)
                  },
                },
              },
              [
                _c("h4", { staticClass: "form-title" }, [_vm._v("管理者登入")]),
                _c("label", { attrs: { for: "Email" } }, [_vm._v("帳號")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.user.Email,
                      expression: "user.Email",
                    },
                  ],
                  attrs: {
                    type: "text",
                    id: "Email",
                    placeholder: "請輸入帳號",
                    required: "",
                  },
                  domProps: { value: _vm.user.Email },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.user, "Email", $event.target.value)
                    },
                  },
                }),
                _c("label", { attrs: { for: "inputPassword" } }, [
                  _vm._v("密碼"),
                ]),
                _c("div", { staticClass: "password-input-wrap" }, [
                  (_vm.showPassword ? "text" : "password") === "checkbox"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.user.Password,
                            expression: "user.Password",
                          },
                        ],
                        attrs: {
                          id: "inputPassword",
                          placeholder: "請輸入密碼",
                          required: "",
                          type: "checkbox",
                        },
                        domProps: {
                          checked: Array.isArray(_vm.user.Password)
                            ? _vm._i(_vm.user.Password, null) > -1
                            : _vm.user.Password,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.user.Password,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.user,
                                    "Password",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.user,
                                    "Password",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.user, "Password", $$c)
                            }
                          },
                        },
                      })
                    : (_vm.showPassword ? "text" : "password") === "radio"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.user.Password,
                            expression: "user.Password",
                          },
                        ],
                        attrs: {
                          id: "inputPassword",
                          placeholder: "請輸入密碼",
                          required: "",
                          type: "radio",
                        },
                        domProps: { checked: _vm._q(_vm.user.Password, null) },
                        on: {
                          change: function ($event) {
                            return _vm.$set(_vm.user, "Password", null)
                          },
                        },
                      })
                    : _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.user.Password,
                            expression: "user.Password",
                          },
                        ],
                        attrs: {
                          id: "inputPassword",
                          placeholder: "請輸入密碼",
                          required: "",
                          type: _vm.showPassword ? "text" : "password",
                        },
                        domProps: { value: _vm.user.Password },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.user, "Password", $event.target.value)
                          },
                        },
                      }),
                  _c(
                    "span",
                    {
                      staticClass: "eye-toggle",
                      on: {
                        click: function ($event) {
                          _vm.showPassword = !_vm.showPassword
                        },
                      },
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: _vm.showPassword ? "eye" : "eye-slash" },
                      }),
                    ],
                    1
                  ),
                ]),
                _c(
                  "button",
                  { staticClass: "login-btn", attrs: { type: "submit" } },
                  [_vm._v("登入")]
                ),
                _c(
                  "span",
                  {
                    staticStyle: {
                      display: "block",
                      float: "right",
                      cursor: "pointer",
                    },
                    on: { click: _vm.forgetPassword },
                  },
                  [_vm._v(" 忘記密碼 ")]
                ),
              ]
            ),
          ]),
        ]),
      ]),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "forgetPasswordModal",
            tabindex: "-1",
            "aria-labelledby": "forgetPasswordModalLabel",
            "aria-hidden": "true",
            "data-backdrop": "static",
          },
        },
        [
          _c("div", { staticClass: "modal-dialog" }, [
            _c(
              "div",
              { staticClass: "modal-content" },
              [
                _c("ValidationObserver", {
                  ref: "form",
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ handleSubmit, reset }) {
                        return [
                          _c(
                            "form",
                            {
                              on: {
                                reset: function ($event) {
                                  $event.preventDefault()
                                  return reset.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "modal-header" }, [
                                _c("span", [_vm._v("忘記密碼")]),
                              ]),
                              _c("div", { staticClass: "modal-body" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("ValidationProvider", {
                                      ref: "forgetPassword",
                                      attrs: {
                                        rules: "required",
                                        name: "帳號",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c(
                                                  "label",
                                                  { attrs: { for: "" } },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "mark" },
                                                      [_vm._v("*")]
                                                    ),
                                                    _vm._v(" 帳號 "),
                                                  ]
                                                ),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model.trim",
                                                      value: _vm.account,
                                                      expression: "account",
                                                      modifiers: { trim: true },
                                                    },
                                                  ],
                                                  attrs: {
                                                    type: "text",
                                                    placeholder: "請輸入帳號",
                                                  },
                                                  domProps: {
                                                    value: _vm.account,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.account =
                                                        $event.target.value.trim()
                                                    },
                                                    blur: function ($event) {
                                                      return _vm.$forceUpdate()
                                                    },
                                                  },
                                                }),
                                                errors[0]
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                        staticStyle: {
                                                          "font-size": "14px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _c("div", { staticClass: "modal-footer" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-secondary",
                                    attrs: {
                                      type: "reset",
                                      "data-dismiss": "modal",
                                    },
                                  },
                                  [_vm._v(" 取消 ")]
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-success",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return handleSubmit(_vm.sendCode)
                                      },
                                    },
                                  },
                                  [_vm._v(" 送出 ")]
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "changePasswordModal",
            tabindex: "-1",
            "aria-hidden": "true",
            "data-backdrop": "static",
          },
        },
        [
          _c("div", { staticClass: "modal-dialog" }, [
            _c(
              "div",
              { staticClass: "modal-content" },
              [
                _c("ValidationObserver", {
                  ref: "changePassword",
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ handleSubmit, reset }) {
                        return [
                          _c(
                            "form",
                            {
                              on: {
                                reset: function ($event) {
                                  $event.preventDefault()
                                  return reset.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "modal-header" }, [
                                _c("span", [_vm._v("變更密碼")]),
                              ]),
                              _c("div", { staticClass: "modal-body" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _c("span", { staticClass: "mark" }, [
                                        _vm._v("*"),
                                      ]),
                                      _vm._v(" 請輸入新密碼"),
                                      _c("span", { staticClass: "mark" }, [
                                        _vm._v(
                                          "(須含大小寫英文及數字，至少12個字元)"
                                        ),
                                      ]),
                                    ]),
                                    _c("ValidationProvider", {
                                      attrs: {
                                        name: "新密碼",
                                        vid: "confirmation",
                                        rules: "required|password_complexity",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model.trim",
                                                      value: _vm.password,
                                                      expression: "password",
                                                      modifiers: { trim: true },
                                                    },
                                                  ],
                                                  attrs: {
                                                    type: "password",
                                                    placeholder: "請輸入新密碼",
                                                  },
                                                  domProps: {
                                                    value: _vm.password,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.password =
                                                        $event.target.value.trim()
                                                    },
                                                    blur: function ($event) {
                                                      return _vm.$forceUpdate()
                                                    },
                                                  },
                                                }),
                                                errors[0]
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                        staticStyle: {
                                                          "font-size": "14px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("ValidationProvider", {
                                      attrs: {
                                        name: "確認新密碼",
                                        rules:
                                          "required|confirmed:confirmation",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c(
                                                  "label",
                                                  { attrs: { for: "" } },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "mark" },
                                                      [_vm._v("*")]
                                                    ),
                                                    _vm._v(" 確認新密碼 "),
                                                  ]
                                                ),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model.trim",
                                                      value:
                                                        _vm.confirmPassword,
                                                      expression:
                                                        "confirmPassword",
                                                      modifiers: { trim: true },
                                                    },
                                                  ],
                                                  attrs: {
                                                    type: "password",
                                                    placeholder:
                                                      "請再次輸入密碼",
                                                  },
                                                  domProps: {
                                                    value: _vm.confirmPassword,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.confirmPassword =
                                                        $event.target.value.trim()
                                                    },
                                                    blur: function ($event) {
                                                      return _vm.$forceUpdate()
                                                    },
                                                  },
                                                }),
                                                errors[0]
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                        staticStyle: {
                                                          "font-size": "14px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("ValidationProvider", {
                                      attrs: {
                                        name: "驗證碼",
                                        rules: "required|alpha_num",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c(
                                                  "label",
                                                  { attrs: { for: "" } },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "mark" },
                                                      [_vm._v("*")]
                                                    ),
                                                    _vm._v(" 驗證碼"),
                                                    _c(
                                                      "span",
                                                      { staticClass: "mark" },
                                                      [
                                                        _vm._v(
                                                          "(已寄至您的信箱)"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model.trim",
                                                      value: _vm.code,
                                                      expression: "code",
                                                      modifiers: { trim: true },
                                                    },
                                                  ],
                                                  attrs: {
                                                    type: "text",
                                                    placeholder: "請輸入驗證碼",
                                                  },
                                                  domProps: { value: _vm.code },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.code =
                                                        $event.target.value.trim()
                                                    },
                                                    blur: function ($event) {
                                                      return _vm.$forceUpdate()
                                                    },
                                                  },
                                                }),
                                                errors[0]
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                        staticStyle: {
                                                          "font-size": "14px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _c("div", { staticClass: "modal-footer" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-secondary",
                                    attrs: {
                                      type: "reset",
                                      "data-dismiss": "modal",
                                    },
                                  },
                                  [_vm._v(" 取消 ")]
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-success",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return handleSubmit(_vm.changePassword)
                                      },
                                    },
                                  },
                                  [_vm._v(" 確認 ")]
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "sub-title" }, [
      _vm._v(" 歡迎回來"),
      _c("br"),
      _vm._v(" 請輸入帳號、密碼登入系統"),
      _c("br"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }